function formatDate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getBrazilNow() {
  return new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" })
  );
}

export function getDateRange(period) {
  const now = getBrazilNow();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  switch (period) {
    case "today":
      return { startDate: formatDate(today), endDate: formatDate(today) };

    case "yesterday":
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return { startDate: formatDate(yesterday), endDate: formatDate(yesterday) };

    case "7days":
      const last7 = new Date(today);
      last7.setDate(today.getDate() - 6);
      return { startDate: formatDate(last7), endDate: formatDate(today) };

    case "thisMonth":
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      return { startDate: formatDate(firstDay), endDate: formatDate(today) };

    case "lastMonth":
      const firstLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const lastLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      return {
        startDate: formatDate(firstLastMonth),
        endDate: formatDate(lastLastMonth),
      };

    case "max":
      const year2025Date = new Date(2025, 9, 1); // 1º do mes 09 do ano 2025 como fallback
      return {
        startDate: formatDate(year2025Date),
        endDate: formatDate(today)
      };

    case "custom":
      return null; // Retorna null para indicar que é customizado

    default:
      // Default: hoje.
      // const defaultFirstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      return { startDate: formatDate(today), endDate: formatDate(today) };
  }
}

// Mantido para retrocompatibilidade
export function getLast30Days() {
  return getDateRange("thisMonth");
}
